/* ==========================================================
 🖤 MJR – Force Default "United States" in Estimate Shipping
 Theme: Sleek v15.2
 Date: 2025-10-18
 Purpose:
   • Detects when cart drawer or shipping calculator opens
   • Waits until country dropdown exists
   • Then auto-selects “United States”
========================================================== */

(function () {
  function selectUnitedStates() {
    const sel =
      document.querySelector('form[is="shipping-calculator"] select[name="address[country]"]') ||
      document.querySelector('select[id^="ShippingCalculatorCountry-"]');
    if (!sel) return false;

    const opts = Array.from(sel.options || []);
    const us =
      opts.find(o => (o.value || "").trim() === "United States") ||
      opts.find(o => (o.value || "").trim() === "US") ||
      opts.find(o => (o.text || "").toLowerCase().includes("united states"));

    if (!us) return false;

    if (sel.value !== us.value) {
      us.selected = true;
      sel.value = us.value;
      sel.dispatchEvent(new Event("change", { bubbles: true }));
      console.log("🇺🇸 Country set to United States");
    }
    return true;
  }

  // Repeatedly check until success
  function waitForCountryDropdown(maxTries = 40) {
    let tries = 0;
    const timer = setInterval(() => {
      const ok = selectUnitedStates();
      if (ok || ++tries > maxTries) clearInterval(timer);
    }, 150);
  }

  // Run immediately (if drawer already open)
  waitForCountryDropdown();

  // Observe drawer open/close attribute changes
  const drawer = document.querySelector("cart-drawer");
  if (drawer) {
    const obs = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.attributeName === "hidden" && !drawer.hasAttribute("hidden")) {
          // Drawer just opened
          setTimeout(waitForCountryDropdown, 300);
        }
      });
    });
    obs.observe(drawer, { attributes: true });
  }

  // Also hook the "Estimate Shipping" button click
  document.addEventListener("click", e => {
    const btn = e.target.closest('[aria-controls^="ShippingCalculator-"]');
    if (btn) setTimeout(waitForCountryDropdown, 300);
  });
})();
